import { ContactsTwoTone, VideoCameraTwoTone } from "@ant-design/icons";
import { Row, Col, Card } from "antd";
import { useEffect, useContext, useState } from "react";

import { Context } from "../../context";
import { Fetch } from "../../fetch";

import "./styles.css";
import LikesReports from "./likesReports";
import ViewsReports from "./viewsReports";

const Dashboard = ({ navTo }) => {
  const { token, apiUrl, superAdmin } = useContext(Context);
  const [subscribers, setSubscribers] = useState(0);
  const [publishedSeries, setPublishedSeries] = useState(0);
  const [publishedEpisodes, setPublishedEpisodes] = useState(0);
  const [publishedMovies, setPublishedMovies] = useState(0);

  useEffect(() => {
    Fetch(`${apiUrl}/admins/dashboard`, token, (result) => {
      setSubscribers(result.subscribers);
      setPublishedSeries(result.liveSeries);
      setPublishedEpisodes(result.episodes);
      setPublishedMovies(result.movies);
    });
  }, [apiUrl, token]);

  return (
    <>
      <Row>
        <Col span={5}>
          <Card className="info-card">
            <ContactsTwoTone
              twoToneColor="#e65251"
              style={{ fontSize: "3em" }}
            />
            <div className="info-card-metric">
              <p>Total Subscribers</p>
              <h3>{subscribers}</h3>
            </div>
          </Card>
        </Col>
        <Col span={5}>
          <Card className="info-card">
            <VideoCameraTwoTone
              twoToneColor="#00ce68"
              style={{ fontSize: "3em" }}
            />
            <div className="info-card-metric">
              <p>All Series</p>
              <h3>{publishedSeries}</h3>
            </div>
          </Card>
        </Col>
        <Col span={5}>
          <Card className="info-card">
            <VideoCameraTwoTone
              twoToneColor="#00ce68"
              style={{ fontSize: "3em" }}
            />
            <div className="info-card-metric">
              <p>Published Episodes</p>
              <h3>{publishedEpisodes}</h3>
            </div>
          </Card>
        </Col>
        <Col span={5}>
          <Card className="info-card">
            <VideoCameraTwoTone
              twoToneColor="#00ce68"
              style={{ fontSize: "3em" }}
            />
            <div className="info-card-metric">
              <p>Published Standalone</p>
              <h3>{publishedMovies}</h3>
            </div>
          </Card>
        </Col>
      </Row>
      <div className="dashboard-reports-wrapper">
        <div className="dashboard-reports">
          <LikesReports />
        </div>
        <div className="dashboard-reports">
          <ViewsReports />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
